import { preloadPage, type PreloadablePage } from '../pages'

export type PageIntentEvent = FocusEvent | PointerEvent

type NetworkConnection = { saveData?: boolean; effectiveType?: string }

export function preloadOnIntent(
  name: PreloadablePage,
  event?: PageIntentEvent
): void {
  const connection = (
    navigator as Navigator & { connection?: NetworkConnection }
  ).connection
  if (
    !navigator.onLine ||
    connection?.saveData ||
    ['slow-2g', '2g'].includes(connection?.effectiveType ?? '')
  )
    return

  if (
    event &&
    'button' in event &&
    (event.button !== 0 ||
      event.isPrimary === false ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey)
  )
    return

  // Covers can contain separate author links and menu buttons. Their intent
  // belongs to those controls, not to the enclosing book navigation.
  if (
    event &&
    event.target instanceof Element &&
    event.currentTarget instanceof Element
  ) {
    const control = event.target.closest('a, button, input, select, textarea')
    if (control && control !== event.currentTarget) return
  }

  void preloadPage(name)
}
